<template>
  <div>
    <b-button
      size="sm"
      variant="success"
      class="edit-icon shadow-none"
      v-b-modal="'modal-1' + index"
    >
      <i class="fa fa-edit"></i>
    </b-button>
    <b-modal
      :id="'modal-1' + index"
      title="Edit Assignment of  Assets"
      size="sm"
    >
      <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
      <b-form @submit.prevent="submitForm">
        <b-form-group
          id="input-group-2"
          label="Plantation Assets:"
          label-for="input-2"
        >
          <b-form-select
            v-model="form._asset_id"
            :options="plantationAssets"
            value-field="_id"
            text-field="name"
          >
            <template #first>
              <b-form-select-option value="" disabled
                >Select Plant Asset</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-2" label="Quantity:" label-for="input-2">
          <b-form-input
            v-model="form.qty"
            placeholder="Enter Quantity"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Current Status:"
          label-for="input-2"
          v-model="form.status"
        >
          <select v-model="form.status" class="form-control">
            <option value="">Select Status</option>
            <option value="1">Completed</option>
            <option value="0">Pending</option>
          </select>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Planned Plantation Date:"
          label-for="input-2"
          v-if="form.status == 0"
        >
          <b-form-datepicker
            id="example-datepicker"
            v-model="form.planned_plantation_date"
            class="mb-2"
          ></b-form-datepicker>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="Plantation Date:"
          label-for="input-2"
          v-if="form.status == 1"
        >
          <b-form-datepicker
            id="example-datepicker1"
            v-model="form.plantation_date"
            class="mb-2"
          ></b-form-datepicker>
        </b-form-group>
         <b-form-group id="input-group-2" label="Remarks:" label-for="input-2">
          <b-form-textarea v-model="form.remarks" placeholder="Enter Remark"></b-form-textarea>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ ok, close }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="submitForm()">
          Update
        </b-button>
        <b-button size="sm" variant="danger" @click="close()"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        _asset_id: "",
        qty: "",
        status: "",
        planned_plantation_date: "",
        plantation_date: "",
        remarks: ""
      },
      plantationAssets: [],
      success: false,
    };
  },
  props: ["plot_id", "index", "data"],
  mounted() {
    this.getPlantationAssets();
  },
  created() {
    this.setupdata();
  },
  methods: {
    setupdata() {
      this.form = Object.assign({}, this.data);
      this.form._asset_id = this.data._asset_id._id;
      this.form.qty = this.data.quantity;
      this.form.plant_asset_id = this.data.quantity;
      this.form.status = this.data.status;
      this.form.planned_plantation_date = this.data.planned_plantation_date
        ? new Date(this.data.planned_plantation_date)
        : "";
      this.form.plantation_date = this.data.plantation_date
        ? new Date(this.data.plantation_date)
        : "";
     this.form.remarks = this.data.remarks;
    },

    getPlantationAssets() {
      window.axios.get("assets/category/plantation").then((resp) => {
        this.plantationAssets = resp.data.data;
        console.log(resp);
      });
    },
    submitForm() {
      this.form["plot_id"] = this.plot_id;
      window.axios
        .put("/plot-assets/" + this.form._id, this.form)
        .then((resp) => {
          console.log(resp);
          this.success = resp.data.message;
          setTimeout(() => (this.success = false), 3000);
          this.$emit("modified", resp.data);
        });
    },
  },
};
</script>

<style scoped>
.edit-icon {
  border: none;
  color: #68561d;
  background-color: #fff;
  margin: 0;
  padding: 0;
}

.fa-edit {
  height: 18px;
  width: 30px;
}
</style>
